var render = function render(){var _vm=this,_c=_vm._self._c;return _c('swatchs-picker',{attrs:{"dir":"ltr","required":_vm.required,"id":_vm.id},model:{value:(_vm.valData),callback:function ($$v) {_vm.valData=$$v},expression:"valData"}})
}
var staticRenderFns = []

export { render, staticRenderFns }